import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';
import { selectUser } from '../../util/store/selectors';
import { useSelector } from '../../util/store/store';
import { operationType, PLAN_MODE } from '../../util/varibles/constants';
import { IOperation2 } from '../../util/varibles/interface';
const type = process.env.REACT_APP_SERVER_TYPE || "" as string;
const serverType: Record<string, string> = {
    "1": 'staging',
    "2": 'production'
}

export function useTrackEvent() {
    const posthog = usePostHog()
    const user = useSelector(selectUser);

    return useCallback((event: string, feature: string, extra: Record<string, unknown> = {}) => {
        const { [type]: environment = '-' } = serverType;
        switch (event) {
            case 'operation_planned': {
                switch (feature) {
                    case 'Plan Operation':
                        const { operation } = extra as { operation: IOperation2 };
                        posthog?.capture(event, {
                            tenant_name: user?.tenant.name,
                            email: user?.email,
                            platform: 'web',
                            feature,
                            operation_type: operationType[operation.operation.operation_type]?.name,
                            vessel_id: operation.vessel.id,
                            vessel_name: operation.vessel.name,
                            plan_mode: operation.operation.plan_mode || PLAN_MODE.MANUAL,
                            environment,
                        });
                        break;
                }
                break;
            }
            case 'route_planned': {
                switch (feature) {
                    case 'Save Route':
                        const { route_mode, source_id, source_name, destination_id, destination_name } = extra;
                        posthog?.capture(event, {
                            tenant_name: user?.tenant.name,
                            email: user?.email,
                            platform: 'web',
                            feature,
                            route_mode,
                            source_id,
                            source_name,
                            destination_id,
                            destination_name,
                            environment,
                        });
                        break;
                }
                break;
            }
        }
    }, [posthog, user])
}
